
import React from 'react';
import { FaInstagram, FaFacebook, FaYoutube, FaEnvelope } from 'react-icons/fa';
import { HOTEL_EMAIL, HOTEL_PHONE } from '../config/hotel';

const PreHeader = () => {
  return (
    <div className="bg-red-900 text-white py-2 px-4 sm:px-6 lg:px-12 w-full" id="site-preheader">
      <div className="container mx-auto flex items-center justify-between flex-wrap lg:flex-nowrap gap-2">
        <div className="flex items-center text-sm sm:text-base lg:text-lg space-x-4">
          <span className="font-semibold">{HOTEL_PHONE}</span>
          <span className="hidden sm:inline">|</span>
          <div className="flex items-center space-x-2">
            <FaEnvelope className="text-base sm:text-lg lg:text-xl shrink-0" />
            <a
              href={`mailto:${HOTEL_EMAIL}`}
              className="text-white hover:text-gray-300 font-medium text-sm sm:text-base"
            >
              {HOTEL_EMAIL}
            </a>
          </div>
        </div>

        <div className="flex items-center space-x-3 lg:space-x-4">
          <a
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-gray-300"
            aria-label="Instagram"
          >
            <FaInstagram className="text-lg sm:text-xl lg:text-2xl" />
          </a>
          <a
            href="https://www.facebook.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-gray-300"
            aria-label="Facebook"
          >
            <FaFacebook className="text-lg sm:text-xl lg:text-2xl" />
          </a>
          <a
            href="https://www.youtube.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-gray-300"
            aria-label="YouTube"
          >
            <FaYoutube className="text-lg sm:text-xl lg:text-2xl" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default PreHeader;
